import React, { useLayoutEffect, useRef, useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { ESTILOS_MOBILE } from './estilosMobile';

// Logo oficial completo (public/). PUBLIC_URL mantiene la ruta válida si la app
// se publica bajo un subdirectorio; hoy vale '' en localhost, Netlify y Cloudflare.
const LOGO_SIGRH = `${process.env.PUBLIC_URL}/logo-sigrh.png`;

// Login Mobile (M.1). Misma lógica que el login Desktop: recibe los mismos
// handlers de App.jsx (onLogin/onError) y el mismo estado (error/verificando).
// Sólo cambia la composición: cabecera de marca compacta + hoja de acceso,
// ambas centradas sobre el mismo eje.
export function LoginMobile({ onLogin, onError, error, verificando }) {
  const refBoton = useRef(null);
  const [anchoBoton, setAnchoBoton] = useState(280);

  // El botón de Google se dibuja en un iframe con ancho fijo en px (200–400):
  // se ajusta al contenedor para no provocar scroll horizontal en 320px.
  // El listener sólo existe mientras la pantalla de login está montada.
  useLayoutEffect(() => {
    const medir = () => {
      const w = refBoton.current ? refBoton.current.clientWidth : 0;
      if (w > 0) setAnchoBoton(Math.max(200, Math.min(400, Math.floor(w))));
    };
    medir();
    window.addEventListener('resize', medir);
    return () => window.removeEventListener('resize', medir);
  }, []);

  return (
    <div className="m-root m-login">
      <style>{ESTILOS_MOBILE}</style>

      <header className="m-login-hero">
        <div className="m-login-logo">
          <img src={LOGO_SIGRH} alt="" />
        </div>
        <div className="m-login-empresa">Aceros y Laminados Leal</div>
        <h1 className="m-login-marca">SIGRH</h1>
        <p className="m-login-sub">Sistema Integral de Recursos Humanos</p>
      </header>

      <main className="m-login-sheet">
        <div className="m-login-inner">
          <h2 className="m-login-titulo">Bienvenido</h2>
          <p className="m-login-texto">Inicia sesión con tu cuenta corporativa para continuar.</p>

          <div className="m-login-card">
            <div className="m-login-google" ref={refBoton}>
              {verificando
                ? <div className="m-login-verificando" role="status">
                    <i className="ti ti-loader-2" aria-hidden="true" style={{ fontSize: '20px' }}></i>
                    Verificando acceso...
                  </div>
                : <GoogleLogin onSuccess={onLogin} onError={onError} size="large" shape="pill" width={String(anchoBoton)} />
              }
            </div>

            <p className="m-login-nota">
              <i className="ti ti-lock" aria-hidden="true"></i>
              <span>Acceso para personal autorizado por RH</span>
            </p>

            {error && (
              <div className="m-login-error" role="alert">
                <i className="ti ti-alert-triangle" aria-hidden="true"></i>
                <span>{error}</span>
              </div>
            )}
          </div>

          <p className="m-login-ayuda">¿Problemas de acceso? Contacta a TI.</p>
        </div>
      </main>
    </div>
  );
}
